// Ce script sert à modifier le lien de la navigation du compte client Recharge pour rediriger vers la page de récompenses.

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElm(".recharge-navigation-customer").then(() => {
  const targetElement = document.querySelector(".recharge-navigation-customer");

  if (targetElement) {
    const newDiv = targetElement.parentNode.cloneNode(true);
    newDiv.innerHTML = targetElement.outerHTML;

    const newLink = newDiv.querySelector("a[href]");
    if (newLink) {
      newLink.href = `${window.Shopify.routes.root}pages/rewards`;
    }

    const newTitle = newDiv.querySelector(".recharge-heading");
    if (newTitle) {
      newTitle.textContent = Theme.translations.loyaltyReferrals;
    }

    targetElement.parentNode.after(newDiv);
  }
});

/**
 * Déconnexion portail ReCharge : forcer la déconnexion session Shopify (routes.account_logout_url).
 * Clic en capture pour rester fiable si le portail re-render le DOM (SPA).
 */
(function attachRechargePortalShopifyLogout() {
  const logoutUrl = Theme.routes && Theme.routes.account_logout_url;
  if (!logoutUrl) return;

  function patchRechargeLogoutAnchors() {
    document.querySelectorAll(".recharge-navigation-logout").forEach((root) => {
      const anchors = root.matches("a[href]") ? [root] : Array.from(root.querySelectorAll("a[href]"));
      anchors.forEach((a) => {
        a.setAttribute("href", logoutUrl);
      });
    });
  }

  document.addEventListener(
    "click",
    function (e) {
      const block = e.target && e.target.closest && e.target.closest(".recharge-navigation-logout");
      if (!block) return;

      const inRechargeUi =
        block.closest("#recharge-customer-portal") ||
        block.closest("[class*='recharge']") ||
        block.closest("[id*='recharge']") ||
        /\/tools\/recurring\//i.test(window.location.pathname || "");
      if (!inRechargeUi) return;

      e.preventDefault();
      e.stopPropagation();
      window.location.href = logoutUrl;
    },
    true
  );

  waitForElm(".recharge-navigation-logout").then(patchRechargeLogoutAnchors);

  const portalRoot = document.getElementById("recharge-customer-portal");
  if (portalRoot) {
    const mo = new MutationObserver(() => {
      patchRechargeLogoutAnchors();
    });
    mo.observe(portalRoot, { childList: true, subtree: true });
  }
})();